import { Ring } from '@uiball/loaders'
import CloseIcon from 'assets/icons/close-icon.svg?component'
import CheckIcon from 'assets/icons/step-done-check.svg?component'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Typography from 'components/UI/Typography'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { GetWsStepStatus } from 'share/types'
import tw, { TwStyle } from 'twin.macro'

const BlockchaingRegisterState = ({ stepStatus, twStyle }: { stepStatus: GetWsStepStatus; twStyle?: TwStyle }) => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <InfoBlock twStyle={[tw`flex items-center gap-x-3 py-7 items-center`, twStyle]}>
        {stepStatus === 'IN_PROGRESS' ? (
          <Fragment>
            <span tw='flex-shrink-0'>
              <Ring size={24} color='var(--primary-color)' />
            </span>
            <Typography weight='bold'>{t('await-pledge-doc')}</Typography>
          </Fragment>
        ) : stepStatus === 'RETRY' ? (
          <Fragment>
            <span tw='flex-shrink-0'>
              <CloseIcon tw='text-primary-middle w-4 h-4' />
            </span>
            <Typography weight='bold'>{t('await-pledge-fail')}</Typography>
          </Fragment>
        ) : (
          <Fragment>
            <span tw='flex-shrink-0'>
              <CheckIcon tw='text-primary-middle w-5 h-5' />
            </span>
            <Typography weight='bold'>{t('await-pledge-success')}</Typography>
          </Fragment>
        )}
      </InfoBlock>
    </Fragment>
  )
}

export default BlockchaingRegisterState
